/**
 * 現在日時の数字を返す
 *
 * @return {Number} 現在日時
 */
const getDateNow = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    const hour = `0${date.getHours()}`.slice(-2);
    const minute = `0${date.getMinutes()}`.slice(-2);

    return parseInt(`${year}${month}${day}${hour}${minute}`, 10);
};

/**
 * data属性で指定した日時に応じて販売前,中,後のボタンを出し分ける
 */
export default () => {
    const targets = document.querySelectorAll('.js-sales-time');

    if (!targets) {
        return;
    }
    for (const target of targets) {
        const start = parseInt(target.dataset.start, 10);
        const end = parseInt(target.dataset.end, 10);
        const now = getDateNow();

        const templateSales = target.querySelector('.js-sales-time__template-sales');
        const templateNotSales = target.querySelector('.js-sales-time__template-not-sales');
        const cloneSales = templateSales.content ? templateSales.content.cloneNode(true) : templateSales.firstElementChild.cloneNode(true);
        const cloneNotSales = templateNotSales.content ? templateNotSales.content.cloneNode(true) : templateNotSales.firstElementChild.cloneNode(true);

        target.innerHTML = '';

        if (now < start) {
            // 販売開始前
            cloneNotSales.querySelector('.js-sales-time__template-not-sales-text').textContent = '販売開始前';
            target.appendChild(cloneNotSales);
        } else if (now > end) {
            // 販売終了
            cloneNotSales.querySelector('.js-sales-time__template-not-sales-text').textContent = '販売終了';
            target.appendChild(cloneNotSales);
        } else {
            // 販売中
            target.appendChild(cloneSales);
        }
    }
};
